import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import selectModal from 'store/modals/selectors';
import { MODAL_MANAGE_BULK_UPDATE } from 'store/modals/modals';
import { setBulkUpdateValue, setBulkUpdateField } from 'store/Credentials/actions';
import get from 'lodash/get';
import BulkTitle from './components/BulkTitle';
import SubmitButtons from './components/SubmitButtons';
import { ModalContent, Wrapper, EditorWrapper, BulkDescription } from './styled';
import BULK_UPDATE_COMPONENTS from './components/components';
import { selectCredentialsSelected, selectModalBulkUpdateField } from 'store/Credentials/selectors';

const BulkUpdateModal = () => {
  const dispatch = useDispatch();

  const bulkUpdateField = useSelector(selectModalBulkUpdateField);
  const showModal = useSelector((state) => selectModal(state, MODAL_MANAGE_BULK_UPDATE));
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const selectedCredentialsCount = credentialsSelected.length;
  const bulkUpdateComponent = get(BULK_UPDATE_COMPONENTS, bulkUpdateField, null);

  useEffect(() => () => {
    dispatch(setBulkUpdateValue(''));
    dispatch(setBulkUpdateField(''));
  }, [dispatch]);

  if (!showModal) return null;
  return (
    <Wrapper>
      <ModalContent>
        <BulkTitle />
        { selectedCredentialsCount > 1 && <BulkDescription>Edit selected Credentials</BulkDescription> }
        <EditorWrapper isBulk={ selectedCredentialsCount > 1 }>
          { bulkUpdateComponent }
        </EditorWrapper>
        <SubmitButtons />
      </ModalContent>
    </Wrapper>
  );
};

export default BulkUpdateModal;
